export default __webpack_public_path__ + "static/media/card1.0393ce68.webp";